var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 39.4 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.4,0H10.98s-.04,.01-.06,.01c-.09,0-.18,.02-.26,.05-.03,.01-.06,.02-.09,.03-.1,.05-.2,.11-.28,.19,0,0,0,0,0,0L.29,10.27s0,0,0,0c-.08,.08-.14,.18-.19,.28-.01,.03-.02,.06-.03,.09-.03,.09-.05,.17-.05,.27,0,.02-.01,.04-.01,.06V55c0,.55,.45,1,1,1H38.4c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1ZM9.98,3.41v6.57H3.41L9.98,3.41Zm27.42,50.59H2V11.98H10.98c.55,0,1-.45,1-1V2h25.42V54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.62,32.63c2.6,0,4.71-2.11,4.71-4.71s-2.11-4.71-4.71-4.71-4.71,2.11-4.71,4.71,2.11,4.71,4.71,4.71Zm0-7.42c1.49,0,2.71,1.22,2.71,2.71s-1.22,2.71-2.71,2.71-2.71-1.22-2.71-2.71,1.22-2.71,2.71-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72,27.35c-.24,.34-.24,.8,0,1.14,.25,.36,6.25,8.83,13.9,8.83s13.65-8.47,13.9-8.83c.24-.34,.24-.8,0-1.14-.25-.36-6.25-8.83-13.9-8.83S5.97,26.99,5.72,27.35Zm13.9-6.83c5.55,0,10.39,5.57,11.83,7.4-1.44,1.83-6.26,7.4-11.83,7.4s-10.39-5.57-11.83-7.4c1.44-1.83,6.28-7.4,11.83-7.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReviews);
export default __webpack_public_path__ + "static/media/view-reviews.673c6832d2eab44427d6792657f016b6.svg";
export { ForwardRef as ReactComponent };